import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProjectsFeatureService } from '@features';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-project-filters',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatIconModule, MatIconButton, ReactiveFormsModule],
  templateUrl: './project-filters.component.html',
})
export class ProjectFiltersComponent {
  _projectsFeature = inject(ProjectsFeatureService);
  searchControl = new FormControl<string>('');

  constructor() {
    this.searchControl.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((value) => this._projectsFeature.searchText.set(value ?? ''));
  }

  resetSearch() {
    this.searchControl.setValue('');
  }
}
